import { useContext } from "react";
import { FindContext } from "@/contexts/FindContext";

export function useFind() {
  const context = useContext(FindContext);
  if (context === undefined) {
    throw new Error("useFind must be used within a FindProvider");
  }
  return context;
}
